import { render } from "./LicensePageMetaLabel.vue?vue&type=template&id=3be6e298&ts=true"
import script from "./LicensePageMetaLabel.vue?vue&type=script&lang=ts"
export * from "./LicensePageMetaLabel.vue?vue&type=script&lang=ts"

import "./LicensePageMetaLabel.vue?vue&type=style&index=0&id=3be6e298&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__